export default [
  // ebg签约发起
  {
    path: "ebg-sales-apply-2025",
    name: "ebgSalesApply2025",
    meta: {
      activename: "ebgSalesApply2025"
    },
    component: () =>
      import("@/views/channelAgreement/twentyTwentyFive/EBG/apply/rad.vue")
  },
  // ebg 签约成功
  {
    path: "ebg-sales-apply-success-2025",
    name: "ebgSalesApplySuccess",
    component: () =>
      import(
        "@/views/channelAgreement/twentyTwentyFive/EBG/apply/applySuccess.vue"
      )
  },
  // ebg续签
  {
    path: "ebg-sales-renewal-2025",
    name: "ebgSalesRenew2025",
    component: () =>
      import("@/views/channelAgreement/twentyTwentyFive/EBG/renew/renew.vue")
  },
  // ebg审批页面
  {
    path: "ebg-sales-approve-2025",
    name: "ebgSalesApprover2025",
    component: () =>
      import("@/views/channelAgreement/twentyTwentyFive/EBG/approve/index.vue")
  },
  // 详情页
  {
    path: "ebg-sales-detail-2025",
    name: "ebgSalesDetail2025",
    component: () =>
      import("@/views/channelAgreement/twentyTwentyFive/EBG/detail/index.vue")
  },
  // 编辑页
  {
    path: "ebg-sales-edit-2025",
    name: "ebgSalesEdit2025",
    component: () =>
      import("@/views/channelAgreement/twentyTwentyFive/EBG/edit/index.vue")
  },
  // 渠道确认
  {
    path: "ebg-sales-channel-confirm-2025",
    name: "ebgSalesChannelConfirm2025",
    component: () =>
      import(
        "@/views/channelAgreement/twentyTwentyFive/EBG/channelConfirm/index"
      )
  },
  // 渠道确认成功
  {
    path: "ebg-sales-channel-confirm_success-2025",
    name: "ebgSalesChannelConfirmSuccess2025",
    component: () =>
      import(
        "@/views/channelAgreement/twentyTwentyFive/EBG/channelConfirm/channelConfirmSuccess"
      )
  },
  // 重新提交
  {
    path: "ebg-sales-resubmit-2025",
    name: "ebgSalesResubmit2025",
    component: () =>
      import("@/views/channelAgreement/twentyTwentyFive/EBG/resubmit/index")
  }
];



// WEBPACK FOOTER //
// ./src/router/ebg2025.js